export const removeBlanksStart = (value) => {
    // Removes blanks at the beginning of the entered value
    return value.trimStart();
};

export const removeBlanks = (value) => {
    // Removes blanks at the beginning and at the end of the entered value
    return value.trim();
};

export const digitsMax9 = (value) => {
    // Strips everything but digits and caps at 9 (e.g. an EIN "33-4602857" -> "334602857")
    if (!value) return value;
    return value.replace(/\D/g, '').slice(0, 9);
};

